import type { IUseCase } from '@/shared/contracts/use-case.contract';
import type { IAppDB } from '@/shared/lib/db';
import { UIError } from '@/shared/utils/ui-error';
import { calculateAddonsPrice } from '../utils/calculate-addons-price';
import { calculateComboChoicesPrice } from '@/modules/stores/utils/combo';

export type UseCaseInput = {
  id: string;
  /** PRAT-187: família só em caixa fechada anda de caixa em caixa. */
  step?: number;
};
export type UseCaseOutput = void;

export class IncrementQuantityUseCase implements IUseCase<UseCaseInput, UseCaseOutput> {
  private db: IAppDB;

  constructor(db: IAppDB) {
    this.db = db;
  }

  async execute(input: UseCaseInput): Promise<UseCaseOutput> {
    const { id } = input;
    const step = Math.max(1, Math.trunc(input.step ?? 1));

    const item = await this.db.items.get(id);

    if (!item) throw new UIError('ITEM_NOT_FOUND', 'Item não encontrado.');

    const newQuantity = item.quantity + step;

    // Recalcula o preço total com a nova quantidade considerando consider_most_expensive
    const addonsTotalPrice = Array.isArray(item.addons) ? calculateAddonsPrice(item.addons) : 0;

    // Combo configurável (PRAT-20): as escolhas somam ao preço por unidade.
    const comboChoicesPrice = calculateComboChoicesPrice(item.combo_choices);

    const newTotalPrice = (item.price + addonsTotalPrice + comboChoicesPrice) * newQuantity;

    await this.db.items.update(id, {
      quantity: newQuantity,
      total_price: newTotalPrice,
    });

    return void 0;
  }
}
